let $ = jQuery;
let hasInitialized = false;

class SectionListSeeMore {

  constructor($seeMore) {
    this.$seeMore = $seeMore;
    this.open = 'profile-section__see-more--open',
    this.$seeMore.off('click').on('click', () => this.handleClick());
  }

  handleClick() {
    if(this.$seeMore.hasClass(this.open)) {
      this.handleHide();
    } else {
      this.handleShow();
    }
  }

  handleShow() {
    this.$seeMore.parent().find('.profile-section__list--extended').slideDown();
    this.$seeMore.text('See Less');
    this.$seeMore.addClass(this.open);
  }

  handleHide() {
    this.$seeMore.parent().find('.profile-section__list--extended').slideUp();
    this.$seeMore.text('See More');
    this.$seeMore.removeClass(this.open);
  }

}

module.exports = {
  attach: function (context, settings) {

    if(hasInitialized) {
      return;
    }

    let $seeMores = $('.profile-section__see-more');
    let list = [];

    $seeMores.each(function(index) {
      let $item = $(this);
      list.push(new SectionListSeeMore($item));
    });

    hasInitialized = true;

  }
};
